export default async function getCountryName (id) {
  const country = await this.$store.dispatch('countries/get', id)
  return country.name
}
